// Bucket length per aggregation mode. Second mode has no fixed spacing, so it
// is left out and never gets gaps marked.
export const GAP_STEP_MS = {
  minute: 60 * 1000,
  hour: 60 * 60 * 1000,
  day: 24 * 60 * 60 * 1000,
};

// A bucket the API leaves out has no point at all, and on a datetime axis Apex
// joins the points either side of it, so the hole looks like real data. Put a
// null point in the first missing bucket so the line breaks there, exactly like
// a bucket that came back empty. points: [{ x: ms, y }] sorted by x.
export const markMissingBuckets = (points, stepMs) => {
  if (!stepMs) return points;
  const out = [];
  points.forEach((point) => {
    const prev = out[out.length - 1];
    if (prev && point.x - prev.x > stepMs * 1.5) {
      out.push({ x: prev.x + stepMs, y: null });
    }
    out.push(point);
  });
  return out;
};
